'use client';

import { ButtonV2 } from '@/app_components/ui/ButtonV2';
import { ContentPlacement } from '@/app_lib/types/analytics';
import { buildSignInRedirectUrl } from '@/app_lib/utils/signinRedirect';
import { cn } from '@/app_lib/utils/utils';

const trackingData = {
  data: {
    // biome-ignore lint/style/useNamingConvention: external data
    contentPlacementCD: 'header',
    eventAction: 'top header links',
    eventCategory: 'navigation',
    eventLabel: 'sign in',
  },
};

export const SignInButton = ({
  className,
  disabled = false,
  isMobile = false,
}: {
  className?: string;
  disabled?: boolean;
  isMobile?: boolean;
}) => {
  const signinHref = buildSignInRedirectUrl(window.location, 'relative');

  const dataCy = isMobile ? ContentPlacement.SigninButtonMobile : ContentPlacement.SigninButtonDesktop;

  return (
    <ButtonV2
      aria-disabled={disabled}
      className={cn(className, 'text-center md:inline-flex')}
      data-cy={dataCy}
      href={signinHref}
      isTertiary
      trackingData={trackingData}
    >
      Sign in
    </ButtonV2>
  );
};
